<div
  class="avatar"
  [ngStyle]="{
  'background-color': colors[name ? name[0].toLowerCase() : 'A'],
  width: width + 'px',
  height: width + 'px'
  }">
  <img loading="lazy" *ngIf="image" [src]="image" alt="" />
  <p *ngIf="!image" [ngStyle]="{ 'font-size': fontSize }">
    {{ name ? name[0] : "" }}{{ lastname ? lastname[0] : "" }}
  </p>
</div>
